// extracted by mini-css-extract-plugin
export default {"text":"InviteFriendsButton--text--z51S9"};